<template>
  <div>
    <v-text-field
      :label="label"
      :rules="rules"
      v-model="valorFormatado"
      v-money="money"
      :required="required"
      prefix=""
      validate-on-blur
      :readonly="bloquearCampo"
      :hint="hint"
      :persistent-hint="persistentHint"
    ></v-text-field>
  </div>
</template>

<script>
import Vue from "vue";
import money from "v-money";

Vue.use(money);
export default {
  name: "mascara-moeda",
  props: ["rules", "label", "valorDefault","required","bloquearCampo","hint","persistent-hint"],
  components: { /*Componentes utilizados*/ money },
  created() /*Metodo de start do componente*/{
    if (this.valorDefault) {
      this.valorFormatado = this.valorDefault.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  watch: { //Propriedades assistidas
    valorFormatado: {
      handler(newValue) { /*Se houver um novo valor*/
        var valorSemformatar = newValue.replace(/[.]/g,"").replace(/[,]/g,".");
        this.$emit("input", valorSemformatar);
      }
    }
  },
  data() {//Declaracao de variaveis
    return {
      valor: "",
      valorFormatado: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },
  methods: {//Declaracao de todos os metodos
    retornaData() {}
  }
};
</script>



